import { render, staticRenderFns } from "./SelectCustomer.vue?vue&type=template&id=f1507bcc&scoped=true&"
import script from "./SelectCustomer.vue?vue&type=script&lang=js&"
export * from "./SelectCustomer.vue?vue&type=script&lang=js&"
import style0 from "./SelectCustomer.vue?vue&type=style&index=0&id=f1507bcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1507bcc",
  null
  
)

export default component.exports